import { RNG } from "rot-js";
import { LevelMap, WorldTile } from "../../engine/map/LevelMap";
import { RNGGenerator } from "../../lib/rng";
import { AdjTypes, drawTile, FloorTypes } from "./Map";
import { generateLootTable } from "./placement/ItemPlacement";

export class ShrineMap extends LevelMap<FloorTypes, AdjTypes> {
  lootTable: Map<string, number> = new Map();
  hasGenerated = false;
  constructor(
    width: number,
    height: number,
    public rng: RNGGenerator,
    public depth = 1
  ) {
    super(drawTile, width, height);
  }

  generate(rng: typeof RNG) {
    if (!this.hasGenerated) {
      generateLootTable(rng, this);
    }
    this.hasGenerated = true;
    this.fillAll(
      () =>
        new WorldTile(FloorTypes.OOB, {
          left: AdjTypes.OPEN,
          up: AdjTypes.OPEN,
          right: AdjTypes.OPEN,
          down: AdjTypes.OPEN,
        })
    );
  }
}
